//#region Libraries
import { useState } from "react";
//#endregion
//#region Utils
import { INIT_DATA_PAGINATOR } from "../constants";
//#endregion

const usePaginator = () => {
    //#region States
    const [dataPaginator, setDataPaginator] = useState({ ...INIT_DATA_PAGINATOR });
    //#endregion
    //#region Functions
    const movePage = currentPage => {
        setDataPaginator(prev => ({
            ...prev, 
            currentPage
        }));
    }
    const clearDataPaginator = () => {
        setDataPaginator({ ...INIT_DATA_PAGINATOR });
    }
    const setQuantityPages = ({
        quantityPages,
        totalRecords
    }) => {
        setDataPaginator(prev => ({
            ...prev, 
            quantityPages,
            totalRecords
        }));
    }
    //#endregion
    return {
        data: dataPaginator,
        movePage,
        clear: clearDataPaginator,
        setQuantityPages
    };
}

export default usePaginator;